<template>
    <v-container>
        <!-- 物件一覧画面 -->
        <v-form>
            <v-card class="headTitle" flat>

                <v-form ref="tableForm" v-model="tableForm" lazy-validation>
                    <ryou-table ref="ryouTable" :rowKey="rowKeyEdit" :title="'表示一覧'" :headers="headers"
                        :queryParams="queryParam" :height="height" :url="url" :showSelect="showSelect"
                        :singleSelect="singleSelect" :needSearch="true">
                        <v-row slot="filterContainer">
                            <v-col cols="3">
                                <v-row class="pa-6">
                                    <RyouSelect class="bukens" :items="dynamicItems" :label="'物件グループ名'" npmrun serve
                                        :itemText="'build_group_name'" :itemValue="'build_group_id'" v-model="select"
                                        :value="select"></RyouSelect>
                                </v-row>
                            </v-col>
                            <v-col cols="2">
                                <v-row class="pa-6">
                                    <RyouSelect class="bukens" :items="room1Items" :label="'部屋状況'"
                                        :itemText="'code_text'" :itemValue="'code_value'" v-model="useSelect"
                                        :value="useSelect"></RyouSelect>
                                </v-row>
                            </v-col>
                            <v-col cols="3">
                                <v-row class="pa-6">
                                    <RyouSelect class="bukens" :items="room2Items" :label="'入居区分'"
                                        :itemText="'code_text'" :itemValue="'code_value'" v-model="dscSelect"
                                        :value="dscSelect"></RyouSelect>
                                </v-row>
                            </v-col>
                            <v-col cols="2">
                                <ryou-checkbox v-model="checkboxInDate" :value="checkboxInDate" :items="checkitems"
                                    :label="'今月入寮'">
                                </ryou-checkbox>
                            </v-col>
                            <v-col cols="2">
                                <ryou-checkbox v-model="checkboxOutDate" :value="checkboxOutDate" :items="checkitems"
                                    :label="'今月退寮'">
                                </ryou-checkbox>
                            </v-col>
                        </v-row>
                    </ryou-table>
                </v-form>
                <v-card-actions>
                    <ryou-black-btn :label="'ファイル出力'" :handlerClick="downloadExcel" :iconCls="'mdi-file-download'">
                    </ryou-black-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-container>
</template>
<script>
    import RyouSelect from "@/components/formInput/RyouSelect.vue";
    import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
    import RyouTable from "@/components/table/RyouTable.vue";
    import { RyouTableMixins } from "@/mixins/RyouTableMixins";
    import RyouCheckbox from "@/components/formInput/RyouCheckbox.vue";
    import fileDownload from "js-file-download";
    export default {
        name: "BuildingPropertyList",
        mixins: [RyouTableMixins],
        components: {
            RyouCheckbox,
            RyouSelect,
            RyouBlackBtn,
            RyouTable
        },
        mounted() {
            this.dateRules.push(this.GlobalRules.required);
        },
        data() {
            return {
                height: 545,
                showSelect: true,
                singleSelect: false,
                checkboxInDate: false,
                checkboxOutDate: false,
                selected: [],//チェックボックス選択の項目データ
                tableForm: true,
                select: "",//コンボボックスの選択値
                useSelect: "",
                dscSelect: "",
                dynamicItems: [],//コンボボックスのすべてのデータ
                room1Items: [],
                room2Items: [],
                rowKeyEdit: "rowIndex",
                dateRules: [],
                checkitems: [],
                tableName: "ryouTable",
                headers: [
                    {
                        text: "物件グループ",
                        class: "blue lighten-2 title",
                        value: "build_group_name",
                        //align: "center",
                        width: "180px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "物件名",
                        class: "blue lighten-2 title",
                        value: "building_name",
                        //align: "center",
                        width: "140px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "部屋番号",
                        class: "blue lighten-2 title",
                        value: "room_id",
                        //align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "入居区分",
                        class: "blue lighten-2 title",
                        value: "dormitory_student_name",
                        //align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "社員番号",
                        class: "blue lighten-2 title",
                        value: "user_id",
                        //align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "氏名",
                        class: "blue lighten-2 title",
                        value: "user_name",
                        //align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "部署",
                        class: "blue lighten-2 title",
                        value: "affiliation",
                        //align: "center",
                        width: "120px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "入社日",
                        class: "blue lighten-2 title",
                        value: "first_recruit_date",
                        //align: "center",
                        width: "135px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "生年月日",
                        class: "blue lighten-2 title",
                        value: "birthday",
                        //align: "center",
                        width: "140px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "本人連絡先",
                        class: "blue lighten-2 title",
                        value: "user_const_phone",
                        //align: "center",
                        width: "180px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "緊急連絡先氏名",
                        class: "blue lighten-2 title",
                        value: "other1_const_name",
                        //align: "center",
                        width: "200px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "緊急連絡先",
                        class: "blue lighten-2 title",
                        value: "other1_const_phone",
                        //align: "center",
                        width: "180px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "入寮日",
                        class: "blue lighten-2 title",
                        value: "in_dormitory_date",
                        //align: "center",
                        width: "165px",
                        sortable: true,
                        groupable: false,
                        filter: this.inDateFilter
                    },
                    {
                        text: "退寮予定日",
                        class: "blue lighten-2 title",
                        value: "out_dormitory_date",
                        //align: "center",
                        width: "165px",
                        sortable: true,
                        groupable: false,
                        filter: this.outDateFilter
                    },
                    {
                        text: "特記事項",
                        class: "blue lighten-2 title",
                        value: "remark",
                        //align: "center",
                        width: "190px",
                        sortable: true,
                        groupable: false
                    },
                    {
                        text: "",
                        value: "build_group_id",
                        width: "1px",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                        filter: this.bgFilter
                    },
                    {
                        text: "",
                        value: "use_status",
                        width: "1px",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                        filter: this.useFilter
                    },
                    {
                        text: "",
                        value: "dormitory_student_class",
                        width: "1px",
                        type: "hidden",
                        sortable: false,
                        groupable: false,
                        filter: this.dscFilter
                    }

                ],
                url: {
                    list: "/buildingPropertyList/buildingGet"
                }
            }
        },

        methods: {
            initViewParams() {
                //ビュー検索用URLパラメータ
                let params =
                    "/" + this.$store.getters.getUserId
                    + "/" + this.$store.getters.getUserClass
                return params;
            },
            initData() {
                //物件グループ検索用URLパラメータ
                let params = {
                    userId: this.$store.getters.getUserId,
                    userClass: this.$store.getters.getUserClass,
                }
                //物件グループ取得
                this.getRequest("/masterMeal/propertyGroupGet", params, this.$store.getters.getUserToken).then(data => {
                    if (data.success) {
                        //物件グループ取得、コンボボックスのすべてのデータ値を賦与
                        this.dynamicItems = data.result;
                        //空要素の追加
                        this.dynamicItems.push(this.select);
                    }
                });
                this.getRequest("/buildingPropertyList/selectListGet", null, this.$store.getters.getUserToken).then((data) => {
                    if (data.success) {
                        this.room1Items = data.result[0].children;//部屋状況選択
                        this.room1Items.push(this.useSelect);
                        this.room2Items = data.result[1].children;//入居区分検索選択
                        this.room2Items.push(this.dscSelect);
                    }
                });
            },
            bgFilter(value) {
                this.$refs.ryouTable.selected = [];
                if (!this.select) {
                    return true;
                }
                return value.toString().toLowerCase().includes(this.select.toLowerCase());
            },
            useFilter(value) {
                this.$refs.ryouTable.selected = [];

                if (!this.useSelect) {
                    return true;
                }

                if (value != null && value != "") {

                    return value.toString().toLowerCase().includes(this.useSelect.toLowerCase());
                }
            },
            dscFilter(value) {
                this.$refs.ryouTable.selected = [];
                if (!this.dscSelect) {
                    return true;
                }
                if (value != null && value != "") {
                    return value.toString().toLowerCase().includes(this.dscSelect.toLowerCase());
                }

            },
            inDateFilter(value) {
                this.$refs.ryouTable.selected = [];
                if (!this.checkboxInDate) {
                    return true;
                }
                if (value != null && value != "") {
                    var aData = new Date().getFullYear() + '/' + this.zeroPadding(new Date().getMonth() + 1)
                    return value.toString().toLowerCase().includes(aData.toString().toLowerCase());
                }
            },
            outDateFilter(value) {
                this.$refs.ryouTable.selected = [];
                if (!this.checkboxOutDate) {
                    return true;
                }
                if (value != null && value != "") {
                    var bData = new Date().getFullYear() + '/' + this.zeroPadding(new Date().getMonth() + 1)
                    return value.toString().toLowerCase().includes(bData.toString().toLowerCase());
                }
            },
            zeroPadding(value) {
                if (value >= 10) {
                    return value
                }
                else {
                    return "0" + value.toString()
                }
            },
            downloadExcel() {
                //チェックボックス選択の項目データ取得
                this.selected = this.selectionRows;
                //CSV作成
                this.postRequest("/buildingPropertyList/buildingInfoCSVCreate/" + this.$store.getters.getUserClass, this.selected, this.$store.getters.getUserToken).then((resp) => {
                    //ファイルパスは戻り
                    if (resp.success) {
                        let streamParams = {
                            filePath: resp.result,
                        };

                        //xlsxはダウンロード
                        this.getStreamRequest('/buildingPropertyList/buildingInfoCSVGet', streamParams, this.$store.getters.getUserToken).then(res => {
                            const blob = new Blob([res], { type: 'application/octet-stream;charset=utf-8' });
                            return fileDownload(blob, "物件一覧_" + this.getDateTime() + ".xlsx");
                        }).catch(function (error) {
                            console.log(error);
                        });
                    }
                });
            },
            getDateTime() {
                const year = new Date().getFullYear()
                const month = new Date().getMonth() + 1 < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1)
                const date = new Date().getDate() < 10 ? '0' + new Date().getDate() : new Date().getDate()
                const hh = new Date().getHours() < 10 ? '0' + new Date().getHours() : new Date().getHours()
                const mm = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes()
                const ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds()
                const nowTime = year + month + date + hh + mm + ss
                return nowTime
            }
        },
        created() {
            var _that = this;
            this.url.list = _that.url.list + this.initViewParams();
            this.initData();
        },
        watch: {
        },
    };
</script>

<style>
    .headTitle {
        padding: 20px;
        height: 200px;
    }
</style>